// extracted by mini-css-extract-plugin
export default {"block":"Ye","info":"Ze","error":"_e","noSpace":"af","optional":"bf"};